module.exports = __webpack_public_path__ + "img/uzbekistan.42de6477.svg";